/**
 * Copying the save code. The async clipboard needs a secure page and the browser's blessing; where
 * it is missing or refuses, the code is selected in its field instead and the player copies it
 * by hand - which works everywhere and never fails silently.
 */

export type CopyOutcome = 'copied' | 'selected';

interface ClipboardLike {
  writeText(text: string): Promise<void>;
}

function clipboard(): ClipboardLike | null {
  const nav = (globalThis as { navigator?: { clipboard?: Partial<ClipboardLike> } }).navigator;
  const board = nav?.clipboard;
  return board !== undefined && typeof board.writeText === 'function' ? (board as ClipboardLike) : null;
}

/** `field` must already show `text`: it is what gets selected when the clipboard cannot be used. */
export async function copyText(text: string, field: HTMLInputElement): Promise<CopyOutcome> {
  const board = clipboard();
  if (board !== null) {
    try {
      await board.writeText(text);
      return 'copied';
    } catch {
      // Permission refused, or the page lost focus: fall through to the selection.
    }
  }
  field.focus();
  if (typeof field.select === 'function') field.select();
  return 'selected';
}
